import axios from "axios";
import { backendUrl } from "../../config";
import { getCookie, deleteCookie } from "./common";
// Create an Axios instance
const api = axios.create({
  baseURL: backendUrl, // Replace with your API base URL
  timeout: 60000, // Set a timeout for requests
  headers: {
    "Content-Type": "application/json",
  },
});

// Add interceptors for requests and responses
api.interceptors.request.use(
  (config) => {
    // Add token to headers

    const getUserData = getCookie("u");
    const userData = getUserData ? JSON.parse(getUserData) : { token: "" };
    let { token } = userData;
    if (token) {
      config.headers.Authorization = `${token}`;
    }
    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

api.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("Response Error:", error.response || error.message);
    if (error.response?.status === 401) {
      console.error("Unauthorized! Redirect to login.");
      deleteCookie("u");
      deleteCookie("uniCommerceToken");
      window.location.href = "/signin";
      // Optionally handle logout or redirect to login here
      return new Promise(() => {});
    }
    return Promise.reject(error);
  }
);

// Generic API handler function
const apiHandler = async ({
  method = "GET",
  route,
  payload = {},
  headers = {},
}) => {
  try {
    const config = {
      method,
      url: route,
      headers: {
        ...headers,
      },
    };

    if (["GET", "DELETE"].includes(method.toUpperCase())) {
      config.params = payload;
    } else {
      config.data = payload;
    }

    console.log(config, "mylog");
    const response = await api(config);

    console.log(response, "APIresponse");
    return response.data;
  } catch (error) {
    console.error(
      `API Call Error: [${method} ${route}]`,
      error.message || error.response
    );
    throw error; // Re-throw the error for component-level handling
  }
};

export default apiHandler;
